/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_HeadingInputs */

const en_cognito_invitation_heading = /** @type {(inputs: Cognito_Invitation_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Recobra`)
};

const pt_br2_cognito_invitation_heading = /** @type {(inputs: Cognito_Invitation_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo à Recobra`)
};

/**
* | output |
* | --- |
* | "Welcome to Recobra" |
*
* @param {Cognito_Invitation_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_heading = /** @type {((inputs?: Cognito_Invitation_HeadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_HeadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_heading(inputs)
	return pt_br2_cognito_invitation_heading(inputs)
});